var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.69328 25.4689C0.689425 26.4724 0.125303 27.8336 0.125 29.2531L0.125 32.0003H2.87217C4.29163 32 5.65284 31.4358 6.65639 30.432L24.511 12.5774L19.5479 7.61426L1.69328 25.4689Z",
    fill: "#00504E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0954 1.02893C30.7695 0.702741 30.3826 0.443974 29.9567 0.267424C29.5307 0.090873 29.0742 0 28.6131 0C28.1521 0 27.6955 0.090873 27.2696 0.267424C26.8437 0.443974 26.4568 0.702741 26.1309 1.02893L21.4395 5.72174L26.4026 10.6848L31.0954 5.99338C31.4216 5.66753 31.6803 5.28059 31.8569 4.85467C32.0334 4.42875 32.1243 3.97221 32.1243 3.51115C32.1243 3.05009 32.0334 2.59356 31.8569 2.16764C31.6803 1.74172 31.4216 1.35478 31.0954 1.02893Z",
    fill: "#00504E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.23c984257772b8f4038f656c28446bd5.svg";
export { ForwardRef as ReactComponent };